<script setup lang="ts">
import { nextTick } from "vue";
import { SNIPPET_VARIABLES } from "@/shared/contracts/snippets";
import { say } from "./say";

const props = defineProps<{ modelValue: unknown; controlId: string; disabled?: boolean }>();
const emit = defineEmits<{ "update:modelValue": [string] }>();
async function insert(variable: string) {
	const control = document.getElementById(props.controlId);
	const text = String(props.modelValue ?? "");
	const editable = control instanceof HTMLTextAreaElement || control instanceof HTMLInputElement;
	const start = editable ? (control.selectionStart ?? text.length) : text.length;
	const end = editable ? (control.selectionEnd ?? start) : start;
	const token = `{{${variable}}}`;
	emit("update:modelValue", text.slice(0, start) + token + text.slice(end));
	await nextTick();
	if (editable) {
		control.focus();
		control.setSelectionRange(start + token.length, start + token.length);
	}
}
</script>

<template>
	<details class="mt-2 text-xs">
		<summary class="cursor-pointer text-accent">{{ say("snippetInsert") }}</summary>
		<div class="mt-2 flex flex-wrap gap-2">
			<button v-for="variable in SNIPPET_VARIABLES" :key="variable" type="button"
				class="rounded border border-border px-2 py-1 disabled:opacity-50"
				:disabled="disabled" @mousedown.prevent @click="insert(variable)">
				{{ say(`snippetVariable.${variable}`) }}
			</button>
		</div>
	</details>
</template>
